// extracted by mini-css-extract-plugin
export default {"wrap":"Input_wrap__R+0IO"};